<div class="switch">
  <button class="switch-btn" (click)="toggleChart()">
    @if (!isPie) {
      <span><i [class]="iconClass.PIE"></i></span>
    }
    @if (isPie) {
      <span><i [class]="iconClass.BAR"></i></span>
    }
  </button>
</div>
<app-echarts-renderer [options]="options" (clicked)="transfertClicked($event)"></app-echarts-renderer>
